import { render } from "./NftConstructorTraits.vue?vue&type=template&id=03e99794"
import script from "./NftConstructorTraits.vue?vue&type=script&lang=js"
export * from "./NftConstructorTraits.vue?vue&type=script&lang=js"

import "./NftConstructorTraits.vue?vue&type=style&index=0&id=03e99794&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__